import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Container } from "../../grid";
export const StyledFooter = styled.footer `
  min-height: 16.25rem;
  position: relative;
`;
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 4rem 0;

  @media ${({ theme }) => theme.device.medium} {
    justify-content: flex-end;
    padding: 4rem 0 2rem;
  }

  @media ${({ theme }) => theme.device.large} {
    justify-content: flex-start;
  }
`;
export const FooterSection = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.device.medium} {
    flex-direction: row;
    min-height: 3.75rem;
  }

  &:first-child {
    @media ${({ theme }) => theme.device.medium} {
      justify-content: space-between;
    }
  }

  &:not(:first-child) {
    flex-direction: column-reverse;
    margin-top: 3rem;

    @media ${({ theme }) => theme.device.medium} {
      flex-direction: row;
      margin-top: 1rem;
      flex-wrap: wrap-reverse;
      min-height: 2.5rem;

      ul {
        margin-left: ${({ wrapped }) => (wrapped ? "-0.5rem" : "0")};
      }

      .copyright {
        ${({ wrapped }) => (wrapped ? `margin-top:0.5rem;` : "")}
      }
    }

    @media ${({ theme }) => theme.device.large} {
      justify-content: flex-end;
      .copyright {
        ${({ wrapped }) => (wrapped ? `margin-right: 0rem;` : "")}
      }
    }
  }
`;
export const FooterContainer = styled((props) => (_jsx(Container, Object.assign({}, props)))) `
  display: flex;
  flex-direction: column;
  padding: 4rem 0;
  box-sizing: border-box;
  width: 100vw;
  max-width: 90rem;
  margin: 0 auto;

  @media ${({ theme }) => theme.device.medium} {
    min-height: 16.25rem;
    padding: 64px 1.5rem 0;
  }
`;
